export default __webpack_public_path__ + "static/media/image-3.937c56c1.jpg";